import {usePage} from '@inertiajs/vue3';
import {useDialog} from 'primevue/usedialog';
import GoBackWindow from '@/Components/editor/components/popups/GoBackWindow.vue';
import {useGenerateAssets} from '@/Composables/generateAssets.js';
import {useDesignApprovalContent} from '@/Composables/useDesignApprovalContent';

export const useReturnToShop = () => {
    const page = usePage();
    const dialog = useDialog();
    const {content} = useDesignApprovalContent();
    const {generateAssetsNow, previewGenerateAssetsNow, finalGenerateAssetsNow} = useGenerateAssets();

    const returnToShop = async (): Promise<void> => {
        if (page.props._tsr?.direct_render_enabled) {
            const generated = await generateAssetsNow();

            if (!generated) {
                return;
            }
        } else {
            await previewGenerateAssetsNow({force: true});
            void finalGenerateAssetsNow();
        }

        dialog.open(GoBackWindow, {
            props: {
                header: content.value.title,
            },
        });
    };

    return {
        returnToShop,
    };
};
